'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import * as React from 'react';

/**
 * The providers for the application.
 * @param children The children to render.
 * @returns The providers for the application.
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      disableTransitionOnChange
      enableColorScheme
      enableSystem
      attribute='class'
      defaultTheme='system'
    >
      {children}
    </NextThemesProvider>
  );
}
